module.exports = __webpack_public_path__ + "static/assets/3d947f9ee0e080ffdd2342722ee14adc.svg";